import script from "./PandoraMenu1.vue?vue&type=script&setup=true&lang=js"
export * from "./PandoraMenu1.vue?vue&type=script&setup=true&lang=js"

import "./PandoraMenu1.vue?vue&type=style&index=0&id=51528720&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51528720"]])

export default __exports__